import cn from 'clsx'
import s from './ProductDetail.module.scss'
import { FC } from 'react'
import { Text } from '@components/ui'

import { Product } from '@commerce/types/product'
// import ProductCard from './ProductCard/ProductCard'
import { LoreThreePage } from '@generated/model/loreThreePage'
import ProductVariant from './ProductVariant'
import Image from 'next/image'
import { LoreThreePageProductDetailsInner } from '@generated/model/loreThreePageProductDetailsInner'
import ArrowDown from '@components/icons/ArrowDown'

type ProductDetailProps = {
  productDetail: LoreThreePageProductDetailsInner
  roadProduct: Product | undefined
  offRoadProduct: Product | undefined
  page: LoreThreePage
  isCurrent: boolean
  updateTab: (index: number) => void
}

const ProductDetail: FC<ProductDetailProps> = ({
  productDetail,
  roadProduct,
  offRoadProduct,
  page,
  isCurrent = false,
  updateTab,
}) => {
  return (
    <>
      <div className={cn(s.root, isCurrent ? s.current : '')}>
        <div className={s.imageContainer}>
          <div className={s.image}>
            <Image
              src={productDetail.image as string}
              alt={productDetail.alt || 'Product Image'}
              objectFit="cover"
              layout="fill"
            />
          </div>
          <div className={s.titlesContainer}>
            {page.product_details?.map((detail, index) => (
              <div
                className={cn(s.titleContainer, {
                  [s.current]: detail.id == productDetail.id,
                })}
                key={`product-detail-${index}`}
              >
                <button onClick={() => updateTab(index)} className={s.button} />
                <div className={s.arrow}>
                  <ArrowDown className={s.arrowIcon} />
                </div>
                <Text className={s.title} variant="headingLarge">
                  {detail.title}
                </Text>
                <div className={s.icon}>
                  <Image
                    src={detail.icon as string}
                    alt={detail.title}
                    width={detail.icon_width}
                    height={detail.icon_height}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
        {productDetail.variants?.map((variant, index) => (
          <ProductVariant
            product={
              variant.primary_color &&
              (variant.primary_color as unknown as string) == 'deep-pink'
                ? roadProduct
                : offRoadProduct
            }
            variant={variant}
            detail={productDetail}
            key={index}
          />
        ))}
      </div>
    </>
  )
}

export default ProductDetail
